import { render, staticRenderFns } from "./PublicIfram.vue?vue&type=template&id=375b6dd2"
import script from "./PublicIfram.vue?vue&type=script&lang=js"
export * from "./PublicIfram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports